// Function to set a cookie with a domain
function setCookie(name, value, days, domain) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
    }
    var domainAttribute = domain ? "; domain=" + domain : "";
    document.cookie = name + "=" + (value || "") + expires + domainAttribute + "; path=/";
}

// Utility function to get a cookie
function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
}

// Redirect to the latest newUrl when the site loads
document.addEventListener("DOMContentLoaded", function() {
    var latestNewUrl = getCookie("newUrl");
    if (latestNewUrl) {
        var currentUrl = new URL(window.location.href);
        var targetUrl = new URL(latestNewUrl);

        // Log the current URL and the latest new URL
        console.log("Current URL:", currentUrl.href);
        console.log("Latest newUrl:", latestNewUrl);

        // Compare the base URLs (protocol + host)
        if (currentUrl.origin !== targetUrl.origin) {
            var newRedirectUrl = targetUrl.origin + currentUrl.pathname + currentUrl.search;
            window.location.href = newRedirectUrl;
        }
    }
});

// Show the modal on page load if it hasn't been clicked within the last 7 days and does not have parameter showBanner=false
window.onload = function() {
    var modal = document.getElementById("store-switch-banner");
    var lastClicked = getCookie("lastClicked");
    var currentDate = new Date().getTime();
    var oneDayAgo = currentDate - (1 * 24 * 60 * 60 * 1000);

    var urlParams = new URLSearchParams(window.location.search);
    var showBanner = urlParams.get('showBanner');
    var lastClickedParam = urlParams.get('lastClicked');

    // Log the lastClicked cookie as a readable timestamp
    if (lastClicked) {
        var lastClickedDate = new Date(parseInt(lastClicked));
        console.log("Last clicked cookie:", lastClickedDate.toString());
    } else {
        console.log("Last clicked cookie: not set");
    }

    // Log oneDayAgo as a readable timestamp
    var oneDayAgoDate = new Date(oneDayAgo);
    console.log("One day ago:", oneDayAgoDate.toString());

    // If the lastClicked parameter is present, set the cookie
    if (lastClickedParam) {
        setCookie("lastClicked", lastClickedParam, 1, ".lacabra.com");
        lastClicked = lastClickedParam;
    }

    if ((showBanner === null || showBanner !== 'false') && (!lastClicked || lastClicked < oneDayAgo)) {
        modal.style.display = "flex";
    }
}

// Function to close the modal
function closeModal() {
    var modal = document.getElementById("store-switch-banner");
    modal.style.display = "none";

    // Store the current timestamp as the last clicked time in a cookie
    setCookie("lastClicked", new Date().getTime(), 1, ".lacabra.com");
}

// Function to redirect to the regional store
function redirectToRegion(region) {
    var currentUrl = new URL(window.location.href);
    var path = currentUrl.pathname;
    var search = currentUrl.search;

    // Remove /da or /de from the path
    path = path.replace(/\/(da|de)(\/|$)/, '/');

    var newUrl;
    if (region === 'us') {
        newUrl = 'https://us.lacabra.com' + path + search;
    } else if (region === 'eu') {
        newUrl = 'https://lacabra.com' + path + search;
    } else {
        newUrl = 'https://lacabra.com' + path + search;
    }

    // Add the showBanner parameter to the URL
    if (search) {
        newUrl += '&showBanner=false';
    } else {
        newUrl += '?showBanner=false';
    }

    // Store the selected region in a cookie
    setCookie("selectedRegion", region, 7, ".lacabra.com");

    // Store the current timestamp as the last clicked time in a cookie
    setCookie("lastClicked", new Date().getTime(), 1, ".lacabra.com");

    // Add the lastClicked cookie value to the URL
    var lastClicked = getCookie("lastClicked");
    if (lastClicked) {
        newUrl += '&lastClicked=' + encodeURIComponent(lastClicked);
    }

    // Extract the base URL from the newUrl
    var urlObject = new URL(newUrl);
    var baseUrl = urlObject.origin;

    // Store the baseUrl in a cookie
    setCookie("newUrl", baseUrl, 7, ".lacabra.com");

    window.location.href = newUrl;
}

// Function to show the modal
function showModal() {
    var modal = document.getElementById("store-switch-banner");
    modal.style.display = "flex";
}

// Update the announcement bar text and mobile menu region text based on the selected region
document.addEventListener("DOMContentLoaded", function() {
    var selectedRegion = getCookie("selectedRegion");
    if (selectedRegion) {
        // Update the announcement bar text
        var announcementMessage = document.querySelector('.store-switch .announcement-bar__message');
        if (announcementMessage) {
            if (selectedRegion === 'eu') {
                announcementMessage.textContent = 'EU';
            } else if (selectedRegion === 'us') {
                announcementMessage.textContent = 'US';
            } else {
                announcementMessage.textContent = 'ROW';
            }
        }

        // Update the mobile menu region text
        var mobileRegionText = document.getElementById("mobileRegionText");
        if (mobileRegionText) {
            if (selectedRegion === 'eu') {
                mobileRegionText.textContent = 'EU';
            } else if (selectedRegion === 'us') {
                mobileRegionText.textContent = 'US';
            } else {
                mobileRegionText.textContent = 'ROW';
            }
        }
    }
});